import { render } from "./MaterialsEducationView.vue?vue&type=template&id=0d43a96d&scoped=true"
import script from "./MaterialsEducationView.vue?vue&type=script&lang=js"
export * from "./MaterialsEducationView.vue?vue&type=script&lang=js"

import "./MaterialsEducationView.vue?vue&type=style&index=0&id=0d43a96d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d43a96d"]])

export default __exports__